import { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { getStudentGrowthMe } from '../api.js'
import { useAuth } from '../auth-context.js'
import { hasEffectiveGrowthData } from '../student-growth-state.js'
import LoadingState from './LoadingState.jsx'

function RequireLearningPlan({ children }) {
  const { isLoggedIn, loading: authLoading } = useAuth()
  const location = useLocation()
  const [state, setState] = useState({ loading: true, hasPlan: false })

  useEffect(() => {
    if (authLoading) return undefined
    if (!isLoggedIn) {
      setState({ loading: false, hasPlan: false })
      return undefined
    }

    const controller = new AbortController()
    setState({ loading: true, hasPlan: false })
    getStudentGrowthMe(controller.signal)
      .then((payload) => setState({ loading: false, hasPlan: hasEffectiveGrowthData(payload) }))
      .catch((error) => {
        if (error.name === 'AbortError') return
        setState({ loading: false, hasPlan: false })
      })
    return () => controller.abort()
  }, [authLoading, isLoggedIn])

  if (authLoading || state.loading) return <LoadingState label="正在读取学习计划..." />

  if (!state.hasPlan) {
    return (
      <Navigate
        to="/onboarding"
        state={{ from: `${location.pathname}${location.search}` }}
        replace
      />
    )
  }

  return children
}

export default RequireLearningPlan
